(function () {
  const STORAGE_KEY = 'somarelle-wishlist-v1';

  const TOGGLE_SELECTOR = '[data-wishlist-toggle]';
  const COUNT_SELECTOR = '[data-wishlist-count]';
  const PAGE_GRID_SELECTOR = '[data-wishlist-grid]';
  const PAGE_EMPTY_SELECTOR = '[data-wishlist-empty]';
  const PAGE_COUNT_SELECTOR = '[data-wishlist-page-count]';
  const TOAST_SELECTOR = '[data-wishlist-toast]';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      console.warn('Wishlist could not be saved.', error);
    }
    updateWishlistUI();
  }

  function isWishlisted(productId) {
    return getWishlist().some((item) => String(item.id) === String(productId));
  }

  function getProductData(button) {
    return {
      id: button.dataset.productId || '',
      title: button.dataset.productTitle || '',
      url:
        button.dataset.productUrl ||
        window.location.pathname + window.location.search ||
        '#',
      image: button.dataset.productImage || '',
      imageHover:
        button.dataset.productImageHover ||
        button.dataset.productImage ||
        '',
      price: button.dataset.productPrice || '',
      vendor: button.dataset.productVendor || ''
    };
  }

  function addToWishlist(item) {
    if (!item.id) return;

    const items = getWishlist();
    const exists = items.some((entry) => String(entry.id) === String(item.id));

    if (!exists) {
      items.unshift(item);
      saveWishlist(items);
      showToast(item);
    }
  }

  function removeFromWishlist(itemId) {
    const items = getWishlist().filter(
      (entry) => String(entry.id) !== String(itemId)
    );
    saveWishlist(items);
  }

  function toggleWishlist(button) {
    const item = getProductData(button);
    if (!item.id) return;

    if (isWishlisted(item.id)) {
      removeFromWishlist(item.id);
    } else {
      addToWishlist(item);
    }
  }

  function updateCounts() {
    const count = getWishlist().length;

    document.querySelectorAll(COUNT_SELECTOR).forEach((el) => {
      el.textContent = count;
      // a zero il pallino sparisce, altrimenti l'header mostra sempre uno 0
      el.hidden = count === 0;
    });
  }

  function updateButtons() {
    document.querySelectorAll(TOGGLE_SELECTOR).forEach((button) => {
      const active = isWishlisted(button.dataset.productId);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const label = button.querySelector('[data-wishlist-label]');
      if (label) {
        label.textContent = active ? 'Remove from wishlist' : 'Add to wishlist';
      }
    });
  }

  function renderWishlistCard(item) {
    const id = escapeHtml(item.id);
    const title = escapeHtml(item.title);
    const url = escapeHtml(item.url || '#');
    const image = escapeHtml(item.image || '');
    const imageHover = escapeHtml(item.imageHover || item.image || '');
    const price = escapeHtml(item.price || '');

    const primaryImageMarkup = image
      ? `<img class="wishlist-card__image wishlist-card__image--primary" src="${image}" alt="${title}" loading="lazy" width="900" height="1200">`
      : `<div class="wishlist-card__placeholder"></div>`;

    const hoverImageMarkup =
      imageHover && imageHover !== image
        ? `<img class="wishlist-card__image wishlist-card__image--hover" src="${imageHover}" alt="${title}" loading="lazy" width="900" height="1200">`
        : '';

    return `
      <article class="wishlist-card" data-wishlist-item="${id}">
        <div class="wishlist-card__media">
          <button
            type="button"
            class="wishlist-card__remove"
            data-wishlist-remove-id="${id}"
            aria-label="Remove ${title} from wishlist"
            title="Remove"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
              <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
          </button>

          <a href="${url}" class="wishlist-card__image-link" aria-label="${title}">
            <div class="wishlist-card__image-wrap">
              ${primaryImageMarkup}
              ${hoverImageMarkup}
            </div>
          </a>
        </div>

        <div class="wishlist-card__footer">
          <div class="wishlist-card__info">
            <h3 class="wishlist-card__title">
              <a href="${url}">${title}</a>
            </h3>
            ${price ? `<div class="wishlist-card__price">${price}</div>` : ''}
          </div>

          <a
  href="${url}"
  class="wishlist-card__cart"
  aria-label="Shop ${title}"
  title="Shop"
>
  <span class="wishlist-card__cart-icon svg-wrapper" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 24 24" focusable="false">
      <path d="M2 10h20l-4 11H6L2 10Zm14-3a4 4 0 0 0-8 0" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  </span>
  <span class="wishlist-card__cart-label">Shop</span>
</a>
        </div>
      </article>
    `;
  }

  function renderWishlistPage() {
    const grid = document.querySelector(PAGE_GRID_SELECTOR);
    if (!grid) return;

    const empty = document.querySelector(PAGE_EMPTY_SELECTOR);
    const countText = document.querySelector(PAGE_COUNT_SELECTOR);
    const items = getWishlist();

    if (countText) {
      countText.textContent =
        items.length === 0
          ? 'No saved products yet'
          : items.length === 1
          ? '1 saved product'
          : `${items.length} saved products`;
    }

    if (items.length === 0) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = items.map(renderWishlistCard).join('');
  }

  function ensureToast() {
    let toast = document.querySelector(TOAST_SELECTOR);

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.setAttribute('data-wishlist-toast', '');
      toast.hidden = true;

      toast.innerHTML = `
        <div class="wishlist-toast__image"></div>
        <div class="wishlist-toast__content">
          <p class="wishlist-toast__text"></p>
          <a href="/pages/wishlist" class="wishlist-toast__link">View your Wishlist</a>
        </div>
        <button type="button" class="wishlist-toast__close" aria-label="Close">×</button>
      `;

      document.body.appendChild(toast);

      const closeBtn = toast.querySelector('.wishlist-toast__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          toast.hidden = true;
        });
      }
    }

    return toast;
  }

  function showToast(item) {
    const toast = ensureToast();
    const imageWrap = toast.querySelector('.wishlist-toast__image');
    const text = toast.querySelector('.wishlist-toast__text');

    if (imageWrap) {
      imageWrap.innerHTML = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}">`
        : '';
    }

    if (text) {
      text.textContent = `The item ${item.title} has been added to your wishlist`;
    }

    toast.hidden = false;

    window.clearTimeout(window.__wishlistToastTimer);
    window.__wishlistToastTimer = window.setTimeout(function () {
      toast.hidden = true;
    }, 3500);
  }

  function updateWishlistUI() {
    updateCounts();
    updateButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', function (event) {
    const toggleButton = event.target.closest(TOGGLE_SELECTOR);
    if (toggleButton) {
      event.preventDefault();
      toggleWishlist(toggleButton);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove-id]');
    if (removeButton) {
      event.preventDefault();
      removeFromWishlist(removeButton.dataset.wishlistRemoveId);
      return;
    }
  });

  document.addEventListener('DOMContentLoaded', updateWishlistUI);
  document.addEventListener('shopify:section:load', updateWishlistUI);
  window.addEventListener('storage', updateWishlistUI);
})();